<template>
  <el-container>
    <el-aside>
      <el-menu :default-openeds="['1', '2', '3']" router>
        <div class="menu-main-title">
          <div class="box">
            <span class="chineseName">金豐集團</span><br />
            <span class="englishName">KINGFONG</span>
          </div>
        </div>
        <el-menu-item index="0" route="/"
          ><i class="el-icon-s-home"></i>回首頁</el-menu-item
        >
        <el-submenu index="1">
          <template slot="title">首頁</template>
          <el-menu-item index="1-1" :route="{ name: '/group/home/carousel' }"
            >輪播圖</el-menu-item
          >
          <el-menu-item index="1-2" :route="{ name: '/group/home/news' }"
            >最新消息</el-menu-item
          >
        </el-submenu>
        <el-menu-item index="2" :route="{ name: '/group/dm-download' }"
          >服務項目DM下載</el-menu-item
        >
        <el-menu-item index="3" :route="{ name: '/group/website-link' }"
          >好站連結</el-menu-item
        >
        <el-menu-item index="4" :route="{ name: '/group/contactUs' }"
          >聯絡我們</el-menu-item
        >
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="content-header" style="height: auto">
        <div class="pageName">
          {{ this.$route.meta.title }}
        </div>
        <el-button class="logoutBtn" @click="logout" size="small"
          >登出</el-button
        >
        <div class="bottom-line"></div>
      </el-header>
      <router-view class="main-content"></router-view>
    </el-container>
  </el-container>
</template>

<script>
import { AdminLogout } from '@/assets/js/api';

export default {
  metaInfo() {
    return {
      title: this.$route.meta.title,
      titleTemplate: '%s | 金豐集團',
    };
  },
  created() {
    const admin = sessionStorage.getItem('_admin');
    if (admin !== 'kingfongAdmin') {
      this.$router.push('/');
    }
  },
  methods: {
    logout() {
      AdminLogout()
        .then(() => {
          sessionStorage.removeItem('_admin');
          this.$router.push({ name: 'login' });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
